import {planTypes} from "@/common/constants";

export default {
  data () {
    return {
      logo: require('@/assets/plans/translated_captions.svg'),
      title: this.$t('billing.translation_caption.title'),
      subtitle: '',
      capacityKey: 'participants',
      planType: planTypes.TRANSLATION_CAPTIONS,
      description: this.$t('billing.translation_caption.desc'),
      licenseTooltip: this.$t('billing.translation_caption.license_tooltip'),
      configDescription: this.$t('billing.translation_caption.config_desc'),
    }
  }
};
